"use client";
import UserContext from '@/context/userContext';
import { getArticleLikesListAPI, likeUnLikeArticleAPI } from '@/services/followListService';
import { showError } from '@/utils/toast';
import React, { useContext, useEffect, useState } from 'react';

const LinkUnLikeSection = ({ articleId, setLikeCountStatus }) => {
    const [isLiked, setIsLiked] = useState(false);
    const context = useContext(UserContext);
    const user = context.user;
    console.log('isLiked=>', isLiked);
    // Like UnLike Article
    const handleLikeUnLikeArticle = async () => {
        if(!user){
            showError('Please login to like this article');
            return;
        }
        const response = await likeUnLikeArticleAPI({ articleId });
        if(response.status === 200) {
            setIsLiked(response.data.liked);
            setLikeCountStatus(response.data.liked)
        }
       
    }
    // Get Article Likes List
    const getArticleLikesList = async () => {
        try {
            const response = await getArticleLikesListAPI({ articleId });
            if(response.status === 200) {
                setIsLiked(response.data.liked);
            }
        } catch (error) {

        }
    }
    useEffect(() => {
        if(articleId){
            if(user){
                getArticleLikesList();
            }
        }
    }, [articleId]);
  return (
    <div onClick={handleLikeUnLikeArticle}>
        {isLiked ? (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="#919BA1" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.70227 5.6206V13.292M8.81652 2.98676L8.17723 5.6206H11.9042C12.1027 5.6206 12.2985 5.66681 12.476 5.75558C12.6536 5.84435 12.808 5.97323 12.9271 6.13202C13.0462 6.29082 13.1267 6.47516 13.1622 6.67044C13.1977 6.86573 13.1872 7.06661 13.1317 7.25716L11.6421 12.3714C11.5647 12.637 11.4032 12.8703 11.1819 13.0363C10.9605 13.2022 10.6914 13.292 10.4147 13.292H1.78442C1.44533 13.292 1.12012 13.1573 0.880342 12.9175C0.640565 12.6777 0.505859 12.3525 0.505859 12.0134V6.89916C0.505859 6.56006 0.640565 6.23486 0.880342 5.99508C1.12012 5.7553 1.44533 5.6206 1.78442 5.6206H3.54884C3.7867 5.62047 4.01982 5.55399 4.22197 5.42864C4.42413 5.30328 4.5873 5.12401 4.69315 4.911L6.89867 0.506348C7.20014 0.510081 7.49687 0.581891 7.76669 0.716413C8.03651 0.850935 8.27244 1.04469 8.45686 1.2832C8.64128 1.52172 8.76941 1.79882 8.83169 2.09381C8.89397 2.3888 8.88878 2.69405 8.81652 2.98676Z" stroke="#919BA1" strokeWidth="1.0125" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ) : (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.70227 5.6206V13.292M8.81652 2.98676L8.17723 5.6206H11.9042C12.1027 5.6206 12.2985 5.66681 12.476 5.75558C12.6536 5.84435 12.808 5.97323 12.9271 6.13202C13.0462 6.29082 13.1267 6.47516 13.1622 6.67044C13.1977 6.86573 13.1872 7.06661 13.1317 7.25716L11.6421 12.3714C11.5647 12.637 11.4032 12.8703 11.1819 13.0363C10.9605 13.2022 10.6914 13.292 10.4147 13.292H1.78442C1.44533 13.292 1.12012 13.1573 0.880342 12.9175C0.640565 12.6777 0.505859 12.3525 0.505859 12.0134V6.89916C0.505859 6.56006 0.640565 6.23486 0.880342 5.99508C1.12012 5.7553 1.44533 5.6206 1.78442 5.6206H3.54884C3.7867 5.62047 4.01982 5.55399 4.22197 5.42864C4.42413 5.30328 4.5873 5.12401 4.69315 4.911L6.89867 0.506348C7.20014 0.510081 7.49687 0.581891 7.76669 0.716413C8.03651 0.850935 8.27244 1.04469 8.45686 1.2832C8.64128 1.52172 8.76941 1.79882 8.83169 2.09381C8.89397 2.3888 8.88878 2.69405 8.81652 2.98676Z" stroke="#919BA1" strokeWidth="1.0125" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        )}
    </div>
  );
}

export default LinkUnLikeSection;